export default "__VITE_ASSET__Cs$bE56K__"